import { gql } from '@apollo/client'
import * as f from '../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription, 
    DataMapper,
    NullClickStrategy,
    SimpleTableDisplayStrategy,
} from '../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'

const tableQuery = gql`
    query BayphoneStatusHistory(
        $bayphoneId:String!,
        $status:String,
        $createdAt:String,
        $orderField:String,
        $first:Int,
        $last:Int,
        $after:String,
        $before:String,
    ) {
        bayphoneStatusHistory(
            bayphoneId:$bayphoneId,
            status:$status,
          	createdAt:$createdAt,
            orderField:$orderField,
            first:$first,
            last:$last,
            after:$after,
            before:$before,
        ) {
            edges {
                node {
                    id
                    bayphone {
                      id
                      deviceType {
                        id
                        name
                      }
                    }
                    state {
                        name
                    }
                    createdAt
                    observation
                    createdBy {
                      email
                    }
                }
            }
            count
            pageInfo {
                hasNextPage
                startCursor
                endCursor
            }
        }
    }
`

let editMutator

let newMutator

let deleteMutator

let unitQuery

const BayphoneStatusHistoryTableCreatorQueries = {tableQuery, editMutator, newMutator, deleteMutator, unitQuery}


class BayphoneStatusHistoryTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "BayphoneStatusHistoryTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(
            this.constructor.getId(), 
            tableName, 
            BayphoneStatusHistoryTableCreatorQueries, 
            new NullClickStrategy(), 
            new SimpleTableDisplayStrategy()
        );
        tableCreator.setDefaultRowHeight(25);

        tableCreator.setDescriptions([
            new TableFieldDescription(
                'status',
                new DataMapper("state.name"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Status'}
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Created At' }
            ),
            new TableFieldDescription(
                'createdBy',
                new DataMapper("createdBy.email"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Created by' }
            ),
            new TableFieldDescription(
                'observation',
                new DataMapper("observation"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Observation'}
            ),
        ])

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(BayphoneStatusHistoryTableCreator)

export default BayphoneStatusHistoryTableCreator
